export const subCheckProviderFormClass = (subCheck, checkType) => {
  const extra = subCheck?.extra_details;
  if (extra != null && Object.prototype.hasOwnProperty.call(extra, 'provider_form_class')) {
    return extra.provider_form_class;
  }

  return checkType?.provider_form_class ?? null;
};

export const subCheckHasProviderId = (subCheck, checkType) => {
  if (!checkType?.has_subchecks) {
    return false;
  }

  const extra = subCheck?.extra_details;
  if (extra != null && Object.prototype.hasOwnProperty.call(extra, 'has_provider_id')) {
    return !!extra.has_provider_id;
  }

  return !!checkType?.has_provider_id;
};

const BOT_ALERT_PRIORITY = { error: 3, support: 2, pending: 1 };

export const getSubCheckBotAlertState = (subCheck, check) => {
  if (!subCheck?.extra_details?.handler_class) {
    return null;
  }
  if (!check?.submitted_at || check?.canceled || subCheck?.canceled || subCheck?.completed_at) {
    return null;
  }
  if (subCheck.bot_message && !subCheck.completed_at) {
    return 'error';
  }
  const waitingOnProvider =
    !!subCheck.processed_at &&
    !subCheck.provider_id &&
    !subCheck.completed_at &&
    !subCheck.bot_message;
  if (waitingOnProvider) {
    return 'pending';
  }
  return 'support';
};

export const getCheckLevelBotAlertState = (check, checkType) => {
  const canLaunch = !!(checkType?.allow_manual_bot_launch && checkType?.on_submission_trigger);
  if (!canLaunch || checkType?.has_subchecks) {
    return null;
  }
  if (!check?.submitted_at || check?.canceled || check?.completed_at) {
    return null;
  }
  if (check.bot_message && !check.completed_at) {
    return 'error';
  }
  if (check.job_at && !check.bot_message) {
    return 'pending';
  }
  return 'support';
};

export const getAggregatedCheckBotAlertState = (check, checkType) => {
  const states = [];
  if (checkType?.has_subchecks) {
    for (const subCheck of check?.sub_checks ?? []) {
      const state = getSubCheckBotAlertState(subCheck, check);
      if (state) {
        states.push(state);
      }
    }
  } else {
    const state = getCheckLevelBotAlertState(check, checkType);
    if (state) {
      states.push(state);
    }
  }
  if (!states.length) {
    return null;
  }
  return states.reduce((best, state) =>
    BOT_ALERT_PRIORITY[state] > BOT_ALERT_PRIORITY[best] ? state : best,
  );
};

export const shouldSubmitCandidate = (submittedCheck, checks, checkTypes) => {
  // If any check required signature, return false
  const requiresSignature = checkTypes.find(checkType => checkType.signature_required);
  if (requiresSignature) return false;

  // Check unfinished checks. If non or only one and the one submitted, return true.
  const unsubmittedChecks = checks.filter(check => !check.submitted_at);
  if (
    unsubmittedChecks.length === 0 ||
    (unsubmittedChecks.length === 1 && unsubmittedChecks[0].id === submittedCheck.id)
  )
    return true;
  else return false;
};
